/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import Modal from "react-modal";
import UI from "@mile-meeting/mile-ui";
import { TReservation } from "apis/meetings/meeting-reservation";
import { getDay, getKorDate, getKorTime, getKorTime_v2, getTimeString } from "utils/date";
import { useEffect } from "react";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
    width: 454,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1001,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  conflictReservationData: TReservation[];
  conflictRestrictionData: TReservation[];
  onRestrict: () => void;
};

const ReservationConflictModal = ({
  modalIsOpen,
  closeModal,
  conflictReservationData,
  conflictRestrictionData,
  onRestrict,
}: Props) => {
  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "40px 48px",
          gap: 40,
          borderRadius: 20,
          background: "white",
          position: "relative",
        }}
      >
        <div className="cancel-btn" style={{ position: "absolute", right: 20, top: 20 }}>
          <UI.IconButton.Normal icon="x" size={20} color="var(--alias-color-label-normal)" onClick={closeModal} />
        </div>
        <div className="upper-section" style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <CautionIcon>
            <UI.Icon name="inform" size={56} color="var(--alias-color-status-cautionary)" />
          </CautionIcon>
          {[...conflictReservationData, ...conflictRestrictionData].length > 0 && (
            <div className="content" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <UI.Typography type="heading01" fontStyle="bold" style={{ textAlign: "center" }}>
                해당 기간에 중복되는 일정이 존재합니다.
                <br />
                중복된 일정을 취소하고 예약 제한을
                <br />
                적용하시겠습니까?
              </UI.Typography>
              <UI.Typography
                type="body01 normal"
                color="var(--alias-color-label-alternative)"
                style={{ textAlign: "center" }}
              >
                ※ 예약 제한 내역과 충돌한 경우에는,
                <br />
                일정 취소 후 제한하기가 불가합니다.
              </UI.Typography>
              <div
                className="conflict-list"
                style={{
                  border: "1px solid var(--alias-color-line-strong)",
                  background: "var(--alias-color-background-normal-alternative)",
                  borderRadius: 12,
                  padding: "16px 20px",
                  maxHeight: 240,
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: 20,
                }}
              >
                <div className="reservation" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
                    중복된 예약
                  </UI.Typography>
                  <UI.Typography type="label01" fontStyle="regular">
                    {conflictReservationData.length === 0 && <p>-</p>}
                    {conflictReservationData.map((item) => {
                      return (
                        <p>
                          · {getKorDate(item.startTime)} ({getDay(item.startTime)}) {getTimeString(item.startTime)} -{" "}
                          {getTimeString(item.endTime)} | {item.title}
                        </p>
                      );
                    })}
                  </UI.Typography>
                </div>
                <div className="reservation" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
                    충돌된 예약 제한
                  </UI.Typography>
                  <UI.Typography type="label01" fontStyle="regular">
                    {conflictRestrictionData.length === 0 && <p>-</p>}
                    {conflictRestrictionData.map((item) => {
                      return (
                        <p>
                          · {getKorDate(item.startTime)} ({getDay(item.startTime)}) {getTimeString(item.startTime)} -{" "}
                          {getKorDate(item.endTime)} ({getDay(item.endTime)}) {getTimeString(item.endTime)}
                        </p>
                      );
                    })}
                  </UI.Typography>
                </div>
              </div>
            </div>
          )}
          {[...conflictReservationData, ...conflictRestrictionData].length === 0 && (
            <UI.Typography type="heading01" fontStyle="bold" style={{ textAlign: "center" }}>
              해당 기간에 중복되는 일정이 없습니다.
              <br />
              예약 제한을 적용하시겠습니까?
            </UI.Typography>
          )}
        </div>
        <UI.Button
          disabled={conflictRestrictionData.length > 0}
          size="large"
          title={
            [...conflictReservationData, ...conflictRestrictionData].length === 0 ? "제한하기" : "취소 후 제한하기"
          }
          onClick={() => {
            if (conflictRestrictionData.length > 0) return;
            onRestrict();
          }}
        />
      </div>
    </Modal>
  );
};

export default ReservationConflictModal;

const CautionIcon = styled.div`
  box-shadow: 0 0 40px 0 rgba(255, 201, 51, 0.42);
  width: 47px;
  height: 47px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
